import { zoom } from './helpers/lightbox-zoom';

window.addEventListener('load', event => {
    let requiredLightboxes = document.querySelectorAll('.requires-lightbox');

    if (requiredLightboxes.length) {
        for ( let lightboxContainer of requiredLightboxes ) {
            const main = lightboxContainer.closest('main');
            let lightbox = lightboxContainer.querySelector('.single-lightbox');

            // shifted lightbox location to be a child of main instead of the section in new update
            // this is to catch for that case
            if (!lightbox) {
                const lightBoxIndex = lightboxContainer.dataset.lightboxLoop;
                if (lightBoxIndex) {
                    lightbox = main.querySelector(`.single-lightbox[data-lightbox-loop="${lightBoxIndex}"`)
                }
            }

            if (lightbox) {
                const lightboxOpen = lightboxContainer.querySelectorAll('.lightbox-open');
                const lightboxBackdrop = lightbox.querySelector('.lightbox-backdrop');
                const lightboxClose = lightbox.querySelector('.lightbox-close');
                const lightboxImage = lightbox.querySelector('.lightbox-image');

                function closeLightBox() {
                    lightbox.classList.add('opacity-0');
                    lightbox.classList.add('pointer-events-none');
                    document.documentElement.classList.remove('body-lock-scroll-modal');
                    const lightboxHide = setTimeout(() => {
                        lightbox.classList.add('hidden');
                    }, 300);
                }

                function openLightBox() {
                    lightbox.classList.remove('hidden');
                    document.documentElement.classList.add('body-lock-scroll-modal');
                    const lightboxShow = setTimeout(() => {
                        lightbox.classList.remove('opacity-0');
                        lightbox.classList.remove('pointer-events-none');
                    }, 50);
                }

                // Zooms on lightbox image when hovered
                if (lightboxImage) {
                    lightboxImage.addEventListener('mousemove', zoom);
                }

                // Closes lightbox on backdrop/close button press
                if (lightboxBackdrop) {
                    lightboxBackdrop.addEventListener('click', () => {
                        closeLightBox();
                    });
                }

                if (lightboxClose) {
                    lightboxClose.addEventListener('click', () => {
                        closeLightBox();
                    });
                }

                // Closes lightbox on key 'esc' press
                if (lightbox) {
                    document.addEventListener("keypress", (e) => {
                        if (!lightbox.classList.contains('hidden')) {
                            if (e.key === "Escape") {
                                closeLightBox();
                            }
                        }
                    });
                }

                // Opens lightbox
                if (lightboxOpen) {
                    for ( const openTrigger of lightboxOpen ) {
                        openTrigger.addEventListener('click', () => {
                            openLightBox();
                        });
                    }
                }
            }
        }
    }
});

